import Cookies from 'universal-cookie';

export async function authorizedFetch(url, options = {}, accessToken) {
    if (!accessToken) throw new Error("Access token is required");

    const cookies = new Cookies();
    const hashCode = cookies.get('hashCode') || "";

    const headers = new Headers(options.headers || {});
    headers.set("Authorization", `${accessToken}${hashCode}`);

    const response = await fetch(url, { ...options, headers });
    if (!response.ok) {
        let errorData;
        try {
            errorData = await response.json();
        } catch {
            errorData = null;
        }
        const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
        error.status = response.status;
        error.statusText = response.statusText;
        error.data = errorData;
        throw error;
    }
    return response.json();
}
